import React from "react";
import "./DrawResults.css";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import draws from "../../data/draws";
import Result from "../Result/Result";

const DrawResults = ({ setIsRegisterPopup }) => {
  const location = useLocation();

  return (
    <>
      {location.pathname === "/results" && (
        <Helmet>
          <title>
            Vikinglotto Draw Results – New Numbers from Best Licensed Game
          </title>
          <meta
            name="description"
            content="Check the latest Vikinglotto draw results from the best licensed lottery in Europe. See new winning numbers, jackpot updates, and prize breakdowns weekly. "
          />
          <link
            rel="canonical"
            href={`https://lottolegenda.com${location.pathname}`}
          />
        </Helmet>
      )}
      <main className="lottolegenda-main lottolegenda-results-page">
        <section className="lottolegenda-how__body pad pad-top flex">
          <div className="lottolegenda-header__demo">
            <h1>Draw Results</h1>
            <button
              className="lottolegenda-header__demo-btn"
              onClick={() => setIsRegisterPopup(true)}
            >
              Try the demo
            </button>
          </div>
          <ul className="lottolegenda-results__container">
            {draws.map((i) => (
              <Result key={i.id} data={i} />
            ))}
          </ul>
        </section>
      </main>
    </>
  );
};

export default DrawResults;
